import { Clipboard } from "@angular/cdk/clipboard";
import { FormDataObject } from "blu-utilities";

export function copyObject(
  object: any,
  clipboard: Clipboard,
  callBack?: () => void,
) {
  const pending = clipboard.beginCopy(object);
  let remainingAttempts = 3;
  const attempt = () => {
    const result = pending.copy();
    if (!result && --remainingAttempts) {
      setTimeout(attempt);
    } else {
      // Remember to destroy when you're done!
      pending.destroy();
      callBack?.();
    }
  };
  attempt();
}

export function parseRequestBody(
  body: FormData | string,
): FormDataObject | null {
  let parsedBody: FormDataObject | null;

  // Check if body is a FormData object
  if (body instanceof FormData) {
    // Convert FormData to JSON
    const formDataObject: FormDataObject = {};
    body.forEach((value, key) => {
      formDataObject[key] = value;
    });
    parsedBody = formDataObject;
  } else {
    // Parse other types (e.g., JSON string)
    try {
      parsedBody = JSON.parse(body);
    } catch (_error) {
      // Handle parsing error
      parsedBody = null;
    }
  }
  // Return the parsed JSON data or null if parsing failed
  return parsedBody;
}
